import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';
import { IWorkbook } from '~src/workbook/ServerApi/types/IWorkbook';

import { IBroadcast } from '../types/IBroadcast';

export interface IGetBroadcastsParams extends IGetItemsParams {
}

export interface IGetBroadcastsResult extends IGetItemsResult {
  broadcasts: IBroadcast[];
  views?: IView[];
  workbooks?: IWorkbook[];
  users?: IUser[];
  viewFavorites?: string[];
}

export class GetBroadcastViewsRequest extends Request<IGetBroadcastsParams, IGetBroadcastsResult> {
  constructor(params: IGetBroadcastsParams) {
    super('listBroadcastViews', params);
  }
}